import * as React from "react";
import { Route, Redirect } from "react-router-dom";
import useUserTheme from "shared/styles/hooks/useUserTheme";
import { ThemeProvider } from "styled-components";
import { PageLoadSpinner } from "../shared/components/PageLoadSpinner";

import { getEnvironments, setIsLoading } from "./actions/AppActions";
import { initialState, reducer } from "./reducers/AppReducer";
import { IAppReducerState } from "./shared/model";

import EnvironmentList from "./components/EnvironmentList";

export const AppContext = React.createContext<IAppReducerState>({ state: initialState, dispatch: () => null });

const App: React.FC<React.PropsWithChildren<unknown>> = () => {

    const [themeType] = useUserTheme();
    const [state, dispatch] = React.useReducer(reducer, initialState);

    React.useEffect(() => {
        setIsLoading(dispatch, true);
        getEnvironments(dispatch);
        setIsLoading(dispatch, false);
    }, []);

    return (
        <AppContext.Provider value={{ state, dispatch }}>
            <ThemeProvider theme={{ mode: themeType }}>
                <React.Suspense fallback={<PageLoadSpinner />}>
                    <Route exact={true} path="/" render={() =>
                        <Redirect
                            to="Default/Default"
                        />
                    } />
                    <EnvironmentList />
                    {state.isLoading && <PageLoadSpinner />}
                </React.Suspense>
            </ThemeProvider>
        </AppContext.Provider>
    );
};

export default App;